import { AgentMetricsDateTypeType } from '../types';

export const AgentMetricsDateTypeTypeTranslation: Record<string, string> = {
  [AgentMetricsDateTypeType.NOW]: 'Сегодня',
  [AgentMetricsDateTypeType.TOMORROW]: 'Вчера',
  [AgentMetricsDateTypeType.WEEK]: 'Неделя',
  [AgentMetricsDateTypeType.MONTH]: 'Месяц',
  [AgentMetricsDateTypeType.CUSTOM]: 'Выберите дату',
};
